var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockedAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36089 4.13738C6.08914 3.40913 7.07687 3 8.10677 3C9.13668 3 10.1244 3.40913 10.8527 4.13738C11.5809 4.86563 11.9901 5.85336 11.9901 6.88326V10.3504C11.9901 10.5934 12.0865 10.8264 12.2584 10.9982C12.4533 11.1932 12.6065 11.2665 12.8207 11.2665C13.0377 11.2665 13.2136 11.4424 13.2136 11.6594C13.2136 11.8763 13.0377 12.0522 12.8207 12.0522H3.39283C3.17588 12.0522 3 11.8763 3 11.6594C3 11.4424 3.17588 11.2665 3.39283 11.2665C3.60708 11.2665 3.76025 11.1932 3.9552 10.9982C4.127 10.8264 4.22351 10.5934 4.22351 10.3504V6.88326C4.22351 5.85336 4.63264 4.86563 5.36089 4.13738ZM6.73188 13.4108C6.73188 13.0853 6.9957 12.8215 7.32113 12.8215H8.89245C9.21787 12.8215 9.48169 13.0853 9.48169 13.4108C9.48169 13.7362 9.21787 14 8.89245 14H7.32113C6.9957 14 6.73188 13.7362 6.73188 13.4108Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedAlarm);
export default __webpack_public_path__ + "static/media/blocked-alarm.3d9bdf756728812d394b82eeab1d0ef8.svg";
export { ForwardRef as ReactComponent };